import React, { useRef, useState } from 'react';
import ENUMS from '../../enums/index';
import Select from 'react-select';
import './payments.scss';
import DatePicker from './../../components/FormElements/DatePicker/DatePicker';

const PaymentsFilter = props => {
  let formRefrence = useRef();
  let [startDate, setStartDate] = useState(' ');
  let [endDate, setEndDate] = useState(' ');
  let [userFullName, setUserFullName] = useState('');
  let [selectedBankPortalName, setSelectedBankPortalNames] = useState([]);
  let [amount, setAmount] = useState();
  let [userMobileNumber, setUserMobileNumber] = useState();
  let [selectedStatusCheckbox, setSelectedStatusCheckbox] = useState([]);
  let [trackingNumber, setTrackingNumber] = useState();

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setUserFullName('');
    setSelectedBankPortalNames('');
    setTrackingNumber('');
    setUserMobileNumber('');
    setAmount('');
    setSelectedStatusCheckbox(null);
    setStartDate(' ');
    setEndDate(' ');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => {
          props.applyFilters(event);
        }}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body col-12">
          <div
            className="d-flex col-12 flex-sm-column flex-md-column flex-lg-row justify-content-between p-0 align-items-center">
            <div className="d-flex col-md-12 col-lg-6 justify-content-between">
              <DatePicker
                marge={true}
                placeholder="تاریخ شروع"
                onChange={d => setStartDate(d)}
                value={startDate}
                name="startDate1"
                className="col-6 date-picker-input"
              />
              <DatePicker
                marge={true}
                placeholder="تاریخ پایان"
                onChange={d => setEndDate(d)}
                value={endDate}
                name="endDate1"
                className="col-6 date-picker-input"
              />
            </div>
            <div className="d-flex flex-column col-md-6 col-lg-3 mx-1">
              <input
                onChange={event => setAmount(event.target.value)}
                value={amount || ''}
                name="amount"
                type="text"
                className="form-control col-12"
                placeholder={locales('tables.amount')}
                maxLength={ENUMS.MAX_LENGTH.amount}
              />
            </div>
            <div className="d-flex flex-column col-md-6 col-lg-3 mx-1">
              <input
                onChange={event => setUserMobileNumber(event.target.value)}
                value={userMobileNumber || ''}
                name="userMobileNumberPart"
                type="text"
                className="form-control col-12"
                placeholder={locales('fields.mobileNumber')}
                maxLength={ENUMS.MAX_LENGTH.mobileNumber}
              />
            </div>

          </div>
          <div
            className="d-flex col-12 flex-sm-column flex-md-column flex-lg-row justify-content-between px-1 pt-4"
            style={{ gap: '5px' }}
          >
            <div className="d-flex flex-column col-md-6 col-lg-4 mx-1">
              <input
                onChange={event => setUserFullName(event.target.value)}
                value={userFullName || ''}
                name="userFullNamePart"
                type="text"
                className="form-control col-12"
                placeholder={locales('tables.fullName')}
                maxLength={ENUMS.MAX_LENGTH.fullName}
              />
              {/* <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small> */}
            </div>
            <div className="d-flex flex-column col-md-6 col-lg-4 mx-1">
              <Select
                placeholder={locales('titles.selectBankName')}
                isMulti={true}
                name="bankPortalName"
                value={selectedBankPortalName}
                options={ENUMS.BANK_NAMES.list.filter((item, index) => {
                  return item.value !== 'TEST_GATEWAY';
                }).map(bankName => ({
                  label: bankName.title,
                  value: bankName.value,
                }))}
                onChange={selectedIds => setSelectedBankPortalNames(selectedIds)}
                className="full-width col-12"
              />
            </div>
            <div className="d-flex flex-column col-md-6 col-lg-4 mx-1">
              <input
                onChange={event => setTrackingNumber(event.target.value)}
                value={trackingNumber || ''}
                name="trackingNumberPart"
                type="text"
                className="form-control col-12"
                placeholder={locales('tables.trackingCodePayment')}
                maxLength={ENUMS.MAX_LENGTH.trackingNumber}
              />
              {/* <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small> */}
            </div>
          </div>
          <div className="d-flex col-12 p-0 my-3">
            <div className="d-flex col-md-12 justify-content-between">
              <span className="col-2 text-center d-flex align-items-center">
                {locales('tables.status')} :{' '}
              </span>
              <div className="col-10 p-0 d-flex justify-content-between align-items-center">
                {ENUMS.BANK_STATUS.list.map((bankStatus, index) => (
                  <div className='d-flex p-0' key={index}>
                    <input
                      type="checkbox"
                      value={bankStatus.value}
                      name={`status`}
                      id={`status-${index}`}
                      className="my-2"
                    />
                    <label className="my-2 mx-1" htmlFor={`status-${index}`}>
                      {bankStatus.title}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="d-flex col-12 justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button type="submit" id="apply-filter-btn-payment" className="btn btn-success w-5 mx-2">
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default PaymentsFilter;
